<template>
  <div id="topbar">
    <b-container>
      <b-row>
        <b-col>
          <div class="topbar_title_container">
            <h1 id="title_topbar">
              <span class="inner_title_topbar">Galerie photo</span>
            </h1>
            <h2 id="subtitle_topbar">
              <span class="inner_subtitle_topbar">{{
                $store.state.module.nom
              }}</span>
            </h2>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="sass" scoped>
</style>